import { LogoUploadCard } from "@/components/LogoUploadCard";
import { TelegramConnectCard } from "@/components/TelegramConnectCard";
import ProfileCard from "@/components/ProfileCard";
import { UserCircle } from "@phosphor-icons/react";

export default function Profile() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight flex items-center gap-2" style={{ fontFamily: "Manrope" }}>
          <UserCircle size={32} weight="duotone" className="text-blue-600" /> Meu Perfil
        </h1>
        <p className="text-muted-foreground text-sm mt-1">Dados cadastrais, troca de senha e de e-mail</p>
      </div>
      <ProfileCard />
      <LogoUploadCard />
      <TelegramConnectCard />
    </div>
  );
}
